/**
 * Privacy Policy Interfaces
 */

export interface PrivacyPolicyItem {
  program_name: string;
  privacy_policy: string; // HTML content
  program_id: number;
  role_id?: number | string | null;
}

export interface PrivacyPolicyApiResponse {
  success?: boolean;
  status?: number;
  data: PrivacyPolicyItem | PrivacyPolicyItem[];
}

export interface PrivacyPolicyUpdatePayload {
  privacy_policy: string;
  program_id: number;
  role_id: number;
}

export interface PrivacyPolicyUpdateApiResponse {
  body: {
    data: {
      message: string;
    };
  };
}
